import NewLockerItemPage from './[itemState]';

export default NewLockerItemPage;
